import { Grid, Typography } from '@mui/material'
import makeStyles from '@mui/styles/makeStyles'
import React from 'react'
import { useFormFactor } from '../../hooks'
import { CampaignActionBtn } from './campaign-btn'
import { ColourSchemes } from './campaign-util'
import { MobileVerticalCampaignBanner } from './mobile-vertical-banner'

const useStyles = makeStyles(({ palette, spacing, typography }) => ({
  homePageBannerCtn: {
    maxHeight: 282,
    backgroundColor: ({ bg }) => bg
  },
  homePageBannerTxtCtn: {
    padding: spacing(3.5, 2.75)
  },
  homePageBannerTitle: {
    color: ({ text }) => text,
    marginBottom: spacing(2)
  },
  homePageBannerDescription: {
    color: ({ text }) => text,
    marginBottom: spacing(3)
  },
  homePageBannerImg: {
    width: '100%',
    height: 282,
    objectFit: 'cover'
  }
}))

export const DesktopCampaignBanner = ({ campaign }) => {
  const { colourScheme, title, body, rectangularImg } = campaign || {}
  const { bg, text } = ColourSchemes[colourScheme] || {}
  const classes = useStyles({ bg, text })

  if (!campaign) return null
  return (
    <Grid className={classes.homePageBannerCtn} container>
      <Grid item xs={7} className={classes.homePageBannerTxtCtn}>
        <Typography className={classes.homePageBannerTitle} variant='h5'>{title}</Typography>
        <Typography
          variant='body2'
          className={classes.homePageBannerDescription}
          dangerouslySetInnerHTML={{ __html: body }}
        />
        <CampaignActionBtn campaign={campaign} />
      </Grid>
      <Grid item xs={5}>
        <img src={rectangularImg?.imgUrl} className={classes.homePageBannerImg} />
      </Grid>
    </Grid>
  )
}

export const HomePageCampaignBanner = props => {
  const { isMobile } = useFormFactor()
  return isMobile ? <MobileVerticalCampaignBanner {...props} /> : <DesktopCampaignBanner {...props} />
}
